<template>
    <div>
        <kgr-month-picker
            :max-month="maxMonth"
            :inline="true"
            :max-year="maxYear"
            :month="month"
            :year="year"
            class="kgr-row"
            @change="onMonthSelected($event)"
        />

        <form
            method="post"
            action=""
            name="kindergartenAction"
        >
            <div class="kgr-row">
                <slot name="tbody"></slot>
            </div>

            <input
                type="hidden"
                name="month"
                :value="selectedMonth"
            />
            <input
                type="hidden"
                name="year"
                :value="selectedYear"
            />

            <div class="kgr-text kgr-text--rightAligned">
                <input
                    id="submitButton"
                    type="submit"
                    class="kgr-button kgr-button--accent right"
                    :value="$t('Rechnungslauf starten')"
                />
            </div>
        </form>
    </div>
</template>

<script>
import MonthPicker from '../common/form/picker/MonthPicker';
import moment from 'moment';

export default {
    components: {
        'kgr-month-picker': MonthPicker,
    },
    props: {
        costOrFee: {
            type: String,
            required: true,
        },
        month: {
            type: Number,
            required: true,
        },
        year: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            now: moment(),
            initialized: false,
            selectedMonth: null,
            selectedYear: null,
            timer: null,
            tableData: null,
            hasRunningJobs: false,
        };
    },
    computed: {
        maxMonth() {
            return +this.now.format('M');
        },
        maxYear() {
            return +moment(this.now).add(1, 'year').format('Y');
        },
    },
    mounted() {
        this.initialized = true;

        this.tableData = {
            kindergartenIds: $('input=[name="kindergartens[]"]').map((i, v) => {
                return $(v).val();
            }).toArray(),
            $runningIcons: {},
            $idleIcons: {},
            $loadingIcons: {},
            $openServiceEntriesDisplay: {},
            $clearableServiceEntriesDisplay: {},
        };

        for (const i in this.tableData.kindergartenIds) {
            const kindergartenId = this.tableData.kindergartenIds[i];
            const $kindergartenRow = $(`tr[data-kindergarten-id="${kindergartenId}"]`);
            this.tableData.$runningIcons[kindergartenId] = $('.queue_status i:nth-of-type(1)', $kindergartenRow).hide();
            this.tableData.$idleIcons[kindergartenId] = $('.queue_status i:nth-of-type(2)', $kindergartenRow).hide();
            this.tableData.$loadingIcons[kindergartenId] = $('i.icon-spinner.icon-pulse', $kindergartenRow).show();
            this.tableData.$openServiceEntriesDisplay[kindergartenId] = $('.open_service_entries_open span', $kindergartenRow);
            this.tableData.$clearableServiceEntriesDisplay[kindergartenId] = $('.open_service_entries_clearable span', $kindergartenRow);
        }
        this.selectedYear = this.year;
        this.selectedMonth = this.month;

        this.monthHasBeenChangedTo();
    },
    methods: {
        onMonthSelected(selection) {
            this.selectedMonth = selection.month;
            this.selectedYear = selection.year;
            if (this.initialized) // due to MonthPicker::mounted()
            {
                this.monthHasBeenChangedTo();
            }
        },
        scheduleReload() {
            this.timer = window.setTimeout(this.monthHasBeenChangedTo, 10000);
        },
        stopReload() {
            clearTimeout(this.timer);
        },
        monthHasBeenChangedTo() {
            this.stopReload();
            const $submitButton = $('#submitButton');
            $submitButton.attr('disabled', true).addClass('disabled');
            const url = `/backend/federation/financial-accounting/batch-processing/service-entry-counts/${this.selectedYear}/${this.selectedMonth}/${this.costOrFee}`;
            const params = { kindergartenIds: this.tableData.kindergartenIds };
            for (const i in this.tableData.kindergartenIds) {
                const kindergartenId = this.tableData.kindergartenIds[i];
                this.tableData.$loadingIcons[kindergartenId].show();
                this.tableData.$runningIcons[kindergartenId].hide();
                this.tableData.$idleIcons[kindergartenId].hide();
                this.tableData.$openServiceEntriesDisplay[kindergartenId].html('');
                this.tableData.$clearableServiceEntriesDisplay[kindergartenId].html('');
            }
            const that = this;
            $.post(url, params, (response) => {
                if (response.success) {
                    that.hasRunningJobs = false;
                    for (const kindergartenId in response.data) {
                        that.tableData.$loadingIcons[kindergartenId].hide();
                        that.tableData.$openServiceEntriesDisplay[kindergartenId].html(response.data[kindergartenId].service_entries_open);
                        that.tableData.$clearableServiceEntriesDisplay[kindergartenId].html(response.data[kindergartenId].service_entries_clearable);
                        that.tableData.$runningIcons[kindergartenId].toggle(!response.data[kindergartenId].queue_idle);
                        const jobRunning = !response.data[kindergartenId].queue_idle;
                        that.tableData.$idleIcons[kindergartenId].toggle(!jobRunning);
                        if (jobRunning) {
                            that.hasRunningJobs = true;
                        }
                    }
                    if (that.hasRunningJobs) {
                        that.scheduleReload();
                    }
                }
                $submitButton.attr('disabled', false).removeClass('disabled');
            }, 'json');
        },
    },
};
</script>
